import React, { useEffect } from 'react';
import NaveBar from '../composant/NaveHero/NaveBar';
import Footer from '../composant/Footer';
import { useParams } from 'react-router-dom';
import BannerS4 from '../composant/BannerS4';
import DroitMinier from '../composant/DroitMinier';
import DroitSocietes from '../composant/DroitSocietes';
import BannerS1 from '../composant/BannerS1';
import DroitFinances from '../composant/DroitFinances';
import BannerS3 from '../composant/BannerS3';
import ExpertiseCooporative from '../composant/ExpertiseCooporative';
import BannerS2 from '../composant/BannerS2';
import DroitEnvironement from '../composant/DroitEnvironement';
import BannerS5 from '../composant/BannerS5';
import DroitAssurance from '../composant/DroitAssurance';
import BannerS6 from '../composant/BannerS6';
import ContentieuxCivil from '../composant/ContentieuxCivil';
import BannerS7 from '../composant/BannerS7';
import BannerS8 from '../composant/BannerS8';
import ResposabilitesEntr from '../composant/ResposabilitesEntr';
import MainContainerAdhesion2 from '../composant/MainContainerAdhesion2';
import ServicesSection from '../composant/ServicesSection';

const ServicesInfos = () => {
  const { services } = useParams();

  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NaveBar />

     
       {services === 'Services1' && <DroitSocietes />}

  
       {services === 'Services2' && <ExpertiseCooporative />}


       {services === 'Services3' && <DroitFinances />}


      {services === 'Services4' && <DroitMinier />}


       {services === 'Services5' && <DroitEnvironement />}

       {services === 'Services6' && <DroitAssurance />}


       {services === 'Services7' && <ContentieuxCivil />}


       {services === 'Services8' && <ResposabilitesEntr />}

      <ServicesSection />
      <MainContainerAdhesion2 />
      <Footer />
    </div>
  );
};

export default ServicesInfos;
